"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const PointPreloader_1 = __importDefault(require("@App/kit/components/Preloaders/PointPreloader"));
const contexts_1 = require("@App/contexts");
const SearchWithCriteria_1 = __importDefault(require("@Components/Search/SearchWithCriteria"));
const ClaimSearchPaginationTable_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/Claim/ClaimSearch/ClaimSearchPaginationTable"));
const form_field_types_1 = require("@App/enum/form-field-types");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const claiming_tool_search_store_1 = require("@App/stores/search/claiming-tool-search-store");
const WizardStepHeading_1 = __importDefault(require("@Components/WizardFlow/WizardStepHeading"));
const ClaimSearch = (props) => {
    const { selectWork } = props;
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { claimingToolSearchStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const handleSearchWithPagination = (pagination = claiming_tool_search_store_1.DEFAULT_CLAIM_PAGINATION) => {
        if (claimingToolSearchStore.claimSearchQuery && Object.keys(claimingToolSearchStore.claimSearchQuery).length) {
            setLoading(true);
            claimingToolSearchStore.setClaimPaginationBody(pagination);
            claimingToolSearchStore.getUnclaimedWorks().then(() => {
                setLoading(false);
            });
        }
    };
    const onChangeLimit = (newLimit) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield claimingToolSearchStore.onChangeLimit(newLimit);
        setLoading(false);
    });
    const handleSearchWithNewCriteria = (searchCriteria, filter) => {
        var _a;
        claimingToolSearchStore.setClaimSearchQuery(searchCriteria);
        claimingToolSearchStore.setClaimFilter(filter.notClaimedBy
            ? undefined
            : { notClaimedBy: (_a = rightsholderStore.currentRightsholder) === null || _a === void 0 ? void 0 : _a.hfaPublisherNumber });
        handleSearchWithPagination();
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_claim_search');
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Claiming Tool' }),
        react_1.default.createElement("div", { className: "claim-search-wrapper" },
            react_1.default.createElement(WizardStepHeading_1.default, { heading: 'Search' }, 'Use the search fields below to locate works with unclaimed shares within our public database. You can enter up\n' +
                '        to 5 search criteria to locate works with unclaimed shares.'),
            react_1.default.createElement("div", { className: "claiming-tool" },
                claimingToolSearchStore.searchCriteriaStore && (react_1.default.createElement(SearchWithCriteria_1.default, { searchCriteriaStore: claimingToolSearchStore.searchCriteriaStore, canAddCriteria: true, handleSearch: handleSearchWithNewCriteria, filterFieldCollections: [
                        {
                            name: 'Claim Search Filters',
                            allowMultiple: false,
                            filterFields: [
                                {
                                    claim: {
                                        type: form_field_types_1.FormFieldTypes.CHECKBOX,
                                        checked: false,
                                        name: 'notClaimedBy',
                                        label: 'Include works claimed by my Member',
                                    },
                                },
                            ],
                        },
                    ], disableSearchButtons: loading })),
                loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(ClaimSearchPaginationTable_1.default, { selectWork: selectWork, limit: claimingToolSearchStore.limit, onChangePage: handleSearchWithPagination, onChangeLimit: onChangeLimit }))))));
};
exports.default = (0, mobx_react_1.observer)(ClaimSearch);
